// extracted by css-extract-rspack-plugin
export default {"root":"NkmLE","button":"pqwpl","description":"ah9rP"};